import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=7cb4f346&scoped=true"
import script from "./InsuranceList.vue?vue&type=script&lang=js"
export * from "./InsuranceList.vue?vue&type=script&lang=js"
import style0 from "./InsuranceList.vue?vue&type=style&index=0&id=7cb4f346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4f346",
  null
  
)

export default component.exports